export type ErrorClassification =
  | "not_found"
  | "validation"
  | "network"
  | "permission"
  | "unknown"

export function classifyError(err: Error): ErrorClassification {
  const msg = err.message.toLowerCase()
  if (msg.includes("not found") || msg.includes("no such") || msg.includes("does not exist"))
    return "not_found"
  if (msg.includes("invalid") || msg.includes("required") || msg.includes("validation"))
    return "validation"
  if (
    msg.includes("timeout") ||
    msg.includes("timed out") ||
    msg.includes("network") ||
    msg.includes("fetch") ||
    msg.includes("connect")
  )
    return "network"
  if (msg.includes("permission") || msg.includes("unauthorized") || msg.includes("forbidden"))
    return "permission"
  return "unknown"
}

const REASON_MAP: Record<ErrorClassification, string> = {
  not_found: "The item wasn't found",
  validation: "The input wasn't valid",
  network: "There was a connection problem",
  permission: "You don't have permission for this",
  unknown: "Something went wrong",
}

/** Check if the error is retryable (network/timeout issues). */
export function isRetryable(err: unknown): boolean {
  const msg = err instanceof Error ? err.message.toLowerCase() : String(err).toLowerCase()
  return (
    msg.includes("timeout") ||
    msg.includes("timed out") ||
    msg.includes("network") ||
    msg.includes("fetch") ||
    msg.includes("connect") ||
    msg.includes("econnrefused") ||
    msg.includes("econnreset") ||
    msg.includes("abort")
  )
}

export function formatToolError(
  err: unknown,
  toolName: string,
): { message: string; classification: ErrorClassification } {
  const error = err instanceof Error ? err : new Error(String(err))
  const classification = classifyError(error)
  const actionLabel = toolName.replace(/_/g, " ")
  return {
    message: `I tried to ${actionLabel} but it didn't work. ${REASON_MAP[classification]}. Try a different approach or refresh the page.`,
    classification,
  }
}
